var config = {
  network: {
    layer1: 'placeholder'
  },
  logLevel: 'debug'
};
export { config };